module.exports = __webpack_public_path__ + "static/media/tree-large.df31399b.svg";